export const PWA_SHELL_STORAGE = {
	pendingUrl: "pofsis:shell:pendingToolUrl",
	pendingPlatform: "pofsis:shell:pendingPlatform",
	skipSession: "pofsis:shell:skipInstall",
	installed: "pofsis:shell:installed",
	continueOnce: "pofsis:shell:continueOnce",
	navLock: "pofsis:shell:navLock",
	lastDestinationUrl: "pofsis:shell:lastDestinationUrl",
};

/** Custom protocol scheme registered in public/manifest.json (not web+pofchat). */
export const PWA_PROTOCOL_SCHEME = "web+pofsis";

/** HTTPS receiver for protocol_handlers %s expansion. */
export const PROTOCOL_LAUNCH_PATH = "/pwa/launch";

export const isShellInstallEnabled = () =>
	String(process.env.REACT_APP_PWA_SHELL_INSTALL || "")
		.trim()
		.toLowerCase() === "true";

/** Unified install gate — platform comes from pending storage, not the URL. */
export const installPath = () => `/pwa/install`;

/**
 * HTTPS continue landing — browser / fallback continuation only.
 * Not the primary installed-PWA launch mechanism (see web+pofsis protocol).
 * Platform comes from pending storage, not the URL.
 */
export const continuePath = () => `/pwa/continue`;
